export default {
    data() {
        return {
            subscription: null
        }
    },

    methods: {
        async loadSubscription() {
            this.loading = true;

            await axios.get('/teacher/pagarme/subscription')
                .then((response) => {
                    this.subscription = response.data.data.subscription || null;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        cancelSubscription() {
            this.$bvModal.msgBoxConfirm('Deseja realmente cancelar a assinatura ?')
                .then((value) => {

                });
        },

        preparePlanWithSubscription(plans, subscription) {

            for (let i = 0; i < plans.length; i++) {
                let plan = plans[i];

                for (let j = 0; j < subscription.items.length; j++) {
                    let planSubscription = subscription.items[j];

                    if (plan.identifier === planSubscription.description) {
                        plans[i]['identifier_pagarme'] = planSubscription.identifier || null;
                        plans[i]['overage_price'] = planSubscription.overage_price || null;
                        plans[i]['price'] = planSubscription.price || null;
                        plans[i]['quantity'] = planSubscription.quantity || null;
                        plans[i]['initial_quantity'] = planSubscription.quantity || null;

                        if (plans[i]['type'] === 'unit') {
                            plans[i]['checked'] = true;
                        } else {
                            plans[i]['options'] = planSubscription.options || [];
                        }
                    }
                }
            }

            return plans;
        }
    }
}
